module.exports = __webpack_public_path__ + "static/img/order-pc-6.f8edb701.png";